"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = require("react-dom");

var _classnames = _interopRequireDefault(require("classnames"));

var _default =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(_default, _React$Component);

  function _default() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(_default)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      isExpanded: true,
      valueExists: false
    };

    _this.setLabelStates = function (isExpanded, valueExists) {
      _this.setState({
        isExpanded: isExpanded,
        valueExists: valueExists
      });
    };

    _this.inputFocused = function () {
      _this.setLabelStates(false, false);
    };

    _this.inputBlurred = function () {
      if (_this.getInputValue()) {
        _this.setLabelStates(false, true);
      } else {
        _this.setLabelStates(true, false);
      }
    };

    _this.getInputValue = function () {
      var inputVal = (0, _reactDom.findDOMNode)(_this.refs.input).value;
      return inputVal ? inputVal.trim() : undefined;
    };

    _this.getContainerClassName = function (isValid) {
      return (0, _classnames.default)({
        invalid: !isValid()
      });
    };

    _this.getLabelClassName = function () {
      return (0, _classnames.default)({
        'label-text': true,
        expanded: _this.state.isExpanded,
        'value-exists': _this.state.valueExists
      });
    };

    _this.renderNoticeText = function () {
      var noticeText = _this.props.noticeText;

      if (!noticeText) {
        return null;
      }

      return _react.default.createElement("div", {
        className: "notice-text"
      }, noticeText);
    };

    return _this;
  }

  (0, _createClass2.default)(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.getInputValue()) {
        // Rearrange the class structure if a value exists
        this.setLabelStates(false, true);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          labelText = _this$props.labelText,
          errorText = _this$props.errorText,
          isValid = _this$props.isValid,
          onChange = _this$props.onChange,
          _onBlur = _this$props.onBlur,
          value = _this$props.value,
          type = _this$props.type;
      return _react.default.createElement("div", {
        className: this.getContainerClassName(isValid)
      }, _react.default.createElement("label", null, _react.default.createElement("span", {
        ref: "label",
        className: this.getLabelClassName()
      }, labelText), _react.default.createElement("input", {
        ref: "input",
        "data-test-id": this.props['data-test-id'],
        type: type,
        onFocus: this.inputFocused,
        onBlur: function onBlur(e) {
          if (typeof _onBlur === 'function') {
            _onBlur(e);
          }

          _this2.inputBlurred();
        },
        autoCapitalize: "off",
        autoCorrect: "off",
        onChange: onChange,
        value: value
      }), _react.default.createElement("br", null), _react.default.createElement("div", {
        className: "error-text"
      }, errorText)), this.renderNoticeText());
    }
  }]);
  return _default;
}(_react.default.Component);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/HomepageLabelledInput.js
// module id = 131
// module chunks = 0